export function initImageUpload() {
  const wrappers = document.querySelectorAll('.image-upload');
  if (!wrappers.length) return;

  wrappers.forEach((wrapper) => {
    const input = wrapper.querySelector('input[type="file"]');
    const dropzone = wrapper.querySelector('.image-upload-dropzone');
    const previews = wrapper.querySelector('.image-upload-previews');

    if (!input || !dropzone || !previews) return;

    let files = [];

    const render = () => {
      previews.innerHTML = '';
      files.forEach((file, index) => {
        const url = URL.createObjectURL(file);
        const item = document.createElement('div');
        item.className = 'image-upload-item';
        const isSingle = input.multiple === false;
        const badgeLabel = isSingle ? 'Main' : index === 0 ? 'Cover' : '';

        item.innerHTML = `
          <img src="${url}" alt="Preview ${index + 1}" />
          ${badgeLabel ? `<span class="image-upload-cover-badge">${badgeLabel}</span>` : ''}
          <button type="button" class="image-upload-remove" aria-label="Remove image" data-index="${index}">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        `;
        previews.appendChild(item);
      });

      // sync the actual input's FileList so it submits with the form
      try {
        const dataTransfer = new DataTransfer();
        files.forEach((file) => dataTransfer.items.add(file));
        input.files = dataTransfer.files;
      } catch (err) {
        // Fallback for older browsers
      }
    };

    const addFiles = (fileList) => {
      const incoming = Array.from(fileList).filter((file) => file.type.startsWith('image/'));
      if (input.multiple === false) {
        files = incoming.slice(0, 1);
      } else {
        files = [...files, ...incoming];
      }
      render();
    };

    input.addEventListener('change', (e) => {
      addFiles(e.target.files);
    });

    previews.addEventListener('click', (e) => {
      const btn = e.target.closest('.image-upload-remove');
      if (!btn) return;
      const index = parseInt(btn.dataset.index, 10);
      files.splice(index, 1);
      render();
    });

    ['dragenter', 'dragover'].forEach((eventName) => {
      dropzone.addEventListener(eventName, (e) => {
        e.preventDefault();
        dropzone.classList.add('is-dragover');
      });
    });

    ['dragleave', 'drop'].forEach((eventName) => {
      dropzone.addEventListener(eventName, (e) => {
        e.preventDefault();
        dropzone.classList.remove('is-dragover');
      });
    });

    dropzone.addEventListener('drop', (e) => {
      if (e.dataTransfer.files.length) {
        addFiles(e.dataTransfer.files);
      }
    });
  });
}